module.exports = __webpack_public_path__ + "assets/total_leads_queue.4a884ce8.svg";